// extracted by mini-css-extract-plugin
export default {"photo":"Users_photo__GZepp"};